import { Link } from "react-router-dom";
import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ExportExcel from "../../components/ExportExcel";
import { toast } from "react-toastify";
import { fetchStudents } from "../../redux/studentSlice";
import * as XLSX from "xlsx";
import { houseList } from "../../utils";
import { formatDate } from "../../functions";

function StudentTransportDetails() {
  const [busDetails, setBusDetails] = useState([]);
  const dispatch = useDispatch();
  const { studentDetails, loading, error } = useSelector(
    (state) => state.students
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  useEffect(() => {
    if (studentDetails.length === 0) {
      dispatch(fetchStudents());
    }
  }, [dispatch, studentDetails.length]);

  const flattenObjectValues = (obj) => {
    let values = [];
    for (let key in obj) {
      const value = obj[key];
      if (typeof value === "object" && value !== null) {
        values = values.concat(flattenObjectValues(value));
      } else if (typeof value === "string") {
        values.push(value);
      }
    }
    return values;
  };

  const filteredRecords = studentDetails.filter((student) => {
    const searchLower = searchTerm.toLowerCase();
    const allValues = flattenObjectValues(student);
    return allValues.some((val) => val.toLowerCase().includes(searchLower));
  });

  console.log(busDetails);

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if less than maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first & last page
      pageNumbers.push(1);

      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 2) {
        endPage = 3;
      } else if (currentPage >= totalPages - 1) {
        startPage = totalPages - 2;
      }

      if (startPage > 2) pageNumbers.push("...");
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
      if (endPage < totalPages - 1) pageNumbers.push("...");

      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  const getValueByPath = (obj, path) => {
    return path.split(".").reduce((acc, key) => {
      if (!acc) return "";
      const match = key.match(/(.*?)\[(\d+)\]/);
      if (match) {
        const arrayKey = match[1];
        const index = parseInt(match[2], 10);
        return acc[arrayKey] && acc[arrayKey][index] !== undefined
          ? acc[arrayKey][index]
          : "";
      }
      return acc[key] !== undefined ? acc[key] : "";
    }, obj);
  };

  const columnMapping = {
    studentId: "Student ID",
    admission_no: "Admission No",
    "studentDetails.admissionDate": "Admission Date",
    "studentDetails.rollNo": "Roll No",
    "studentDetails.name": "Student Name",
    "studentDetails.gender": "Gender",
    currentClass: "Class",
    "studentDetails.currentSection": "Section",
    "studentDetails.dateOfBirth": "Date of Birth",
    "studentDetails.phoneNo": "Phone No",
    "studentDetails.house": "House",
    "studentDetails.category": "Category",
    "studentDetails.aadhar_no": "Aadhaar Card No.",
    "studentDetails.bloodGroup": "Blood Group",
    "studentDetails.handicap": "Handicap",
    "transportFacility.busStop": "Bus Stop",
    "feeDetails.transportFee.amt": "Transport Fee",
    "transportFacility.vehicleNo": "Vehicle No",
    "transportFacility.busNumber": "Bus No",
    "parentDetails[0].email": "Email ID",
    presentAddress: "Present Address",
    "parentDetails[0].name": "Father's Name",
    "parentDetails[1].name": "Mother's Name",
  };

  const handleExportExcel = () => {
    if (!columnMapping || Object.keys(columnMapping).length === 0) {
      alert("Column mapping is missing or empty.");
      return;
    }

    const formattedData = studentDetails.map((item) => {
      const formattedItem = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        formattedItem[header] = getValueByPath(item, key);
      });
      return formattedItem;
    });
    ExportExcel(studentDetails, "StudentDetails", columnMapping);
  };

  useEffect(() => {
    const fetchBusDetails = async () => {
      try {
        const response = await axios.get(`${server}/allBusDetailsMongoDb`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        const busData = response.data?.["body-json"]?.body?.data;
        if (Array.isArray(busData)) {
          setBusDetails(busData);
        } else {
          console.error("Invalid data format: Expected an array", busData);
          setBusDetails([]);
        }
      } catch (error) {
        console.error("Error fetching bus details:", error);
      }
    };

    fetchBusDetails();
  }, []);

  const handleExportClassWiseExcel = () => {
    if (!columnMapping || Object.keys(columnMapping).length === 0) {
      alert("Column Missing");
      return;
    }

    const workbook = XLSX.utils.book_new();
    const classGroups = {};

    studentDetails.forEach((student) => {
      const cls = student.currentClass;
      const sec = student.studentDetails.currentSection;

      if (!classGroups[cls]) {
        classGroups[cls] = {};
      }

      if (!classGroups[cls][sec]) {
        classGroups[cls][sec] = [];
      }

      const formattedItem = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        let value = getValueByPath(student, key);

        if (key === "transportFacility.busStop" && typeof value === "string") {
          value = value.toUpperCase();
        }

        if (
          (key === "studentDetails.dateOfBirth" ||
            key === "studentDetails.admissionDate") &&
          value
        ) {
          value = formatDate(value);
        }

        formattedItem[header] = value;
      });

      classGroups[cls][sec].push(formattedItem);
    });

    Object.entries(classGroups).forEach(([className, sections]) => {
      const combinedData = [];

      const sortedSections = Object.keys(sections).sort();

      sortedSections.forEach((sec) => {
        const students = sections[sec];
        students.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));
        combinedData.push({ "Student ID": `Section ${sec}` });
        combinedData.push(...students);
        combinedData.push({});
      });

      const worksheet = XLSX.utils.json_to_sheet(combinedData, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workbook, worksheet, className);
    });

    XLSX.writeFile(workbook, "Student_ClassWise.xlsx");
    toast.success("Report Generated");
  };

  const handleExportWalkerStudentsExcel = () => {
    if (!columnMapping || Object.keys(columnMapping).length === 0) {
      alert("Column Missing");
      return;
    }

    const workbook = XLSX.utils.book_new();
    const walkerStudents = studentDetails.filter(
      (student) => !getValueByPath(student, "transportFacility.busStop")
    );

    if (walkerStudents.length === 0) {
      toast.error("No walker students found");
      return;
    }

    const formattedData = walkerStudents.map((student) => {
      const row = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        row[header] = getValueByPath(student, key);
      });
      return row;
    });

    formattedData.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Walker Students");

    XLSX.writeFile(workbook, "Students_Walker.xlsx");
    toast.success("Report Generated");
  };

  const handleExportTransportAvailingStudentsExcel = () => {
    if (!columnMapping || Object.keys(columnMapping).length === 0) {
      alert("Column Missing");
      return;
    }

    const workbook = XLSX.utils.book_new();

    const transportStudents = studentDetails.filter(
      (student) => !!getValueByPath(student, "transportFacility.busStop")
    );

    if (transportStudents.length === 0) {
      toast.error("No transport students found");
      return;
    }

    const formattedData = transportStudents.map((student) => {
      const row = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        row[header] = getValueByPath(student, key);
      });
      return row;
    });

    formattedData.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transport Students");

    XLSX.writeFile(workbook, `Students_AvailingTransport.xlsx`);
    toast.success("Report Generated");
  };

  const handleDownloadBirthdayReport = () => {
    const workbook = XLSX.utils.book_new();
    const today = new Date();
    const todayMonthDay = `${String(today.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(today.getDate()).padStart(2, "0")}`;

    const birthdayStudents = studentDetails.filter((student) => {
      const dob = getValueByPath(student, "studentDetails.dateOfBirth");
      if (!dob) return false;
      const [year, month, day] = dob.split("-");
      return `${month}-${day}` === todayMonthDay;
    });

    if (birthdayStudents.length === 0) {
      toast.error("No birthdays today");
      return;
    }

    const formattedData = birthdayStudents.map((student) => {
      const row = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        row[header] = getValueByPath(student, key);
      });
      return row;
    });

    formattedData.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Today's Birthdays");

    const formattedDate = today.toISOString().split("T")[0];
    XLSX.writeFile(workbook, `Students_Birthday_${formattedDate}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportHouseWiseExcel = () => {
    const workbook = XLSX.utils.book_new();

    houseList.forEach((house) => {
      const studentsInHouse = studentDetails.filter(
        (student) => student?.studentDetails?.house === house
      );

      if (studentsInHouse.length === 0) return;

      const formattedData = studentsInHouse.map((student) => {
        const row = {};
        Object.entries(columnMapping).forEach(([key, header]) => {
          row[header] = getValueByPath(student, key);
        });
        return row;
      });

      // Sort by roll number (as number)
      formattedData.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(workbook, worksheet, house);
    });

    const today = new Date().toISOString().split("T")[0];
    XLSX.writeFile(workbook, `Students_HouseWise_${today}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportBusWiseExcel = () => {
    const workbook = XLSX.utils.book_new();
    const busNos = [
      ...new Set(
        studentDetails
          .map((student) => student?.transportFacility?.busNumber)
          .filter((busNo) => busNo !== undefined && busNo !== null)
      ),
    ].sort((a, b) => {
      return Number(a) - Number(b);
    });

    busNos.forEach((busNo) => {
      const studentsInBus = studentDetails.filter(
        (student) => student?.transportFacility?.busNumber === busNo
      );

      if (studentsInBus.length === 0) return;

      const formattedData = studentsInBus.map((student) => {
        const row = {};
        Object.entries(columnMapping).forEach(([key, header]) => {
          row[header] = getValueByPath(student, key);
        });
        return row;
      });

      // Sort by Roll No inside each sheet
      formattedData.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(workbook, worksheet, `${busNo}`);
    });

    const today = new Date().toISOString().split("T")[0];
    XLSX.writeFile(workbook, `Students_BusWise_${today}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportGenderWiseExcel = () => {
    if (!columnMapping || Object.keys(columnMapping).length === 0) {
      alert("Column Missing");
      return;
    }

    const workbook = XLSX.utils.book_new();
    const genderGroups = {};

    studentDetails.forEach((student) => {
      const gender = student.studentDetails?.gender || "Unknown";

      if (!genderGroups[gender]) {
        genderGroups[gender] = [];
      }

      const formattedItem = {};
      Object.entries(columnMapping).forEach(([key, header]) => {
        let value = getValueByPath(student, key);

        // Join array values
        if (Array.isArray(value)) {
          value = value.join(", ");
        }

        // Uppercase Bus Stop
        if (key === "transportFacility.busStop" && typeof value === "string") {
          value = value.toUpperCase();
        }

        // Format date fields
        if (
          (key === "studentDetails.dateOfBirth" ||
            key === "studentDetails.admissionDate") &&
          value
        ) {
          value = formatDate(value);
        }

        formattedItem[header] = value;
      });

      genderGroups[gender].push(formattedItem);
    });

    // Create one sheet per gender
    Object.entries(genderGroups).forEach(([gender, students]) => {
      students.sort((a, b) => Number(a["Roll No"]) - Number(b["Roll No"]));
      const worksheet = XLSX.utils.json_to_sheet(students, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workbook, worksheet, gender.slice(0, 31));
    });

    XLSX.writeFile(workbook, `Students_GenderWise.xlsx`);
    toast.success("Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((student, index) => (
                          <tr key={index}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span class="text-dark">Student ID</span> &mdash;{" "}
                              {student.studentId}
                              <br />
                              <span class="text-dark">Admission No</span>{" "}
                              &mdash; {student.studentDetails.admission_no}{" "}
                              <br />
                              <span class="text-dark">Admission Date</span>{" "}
                              &mdash; {student.studentDetails.admissionDate}{" "}
                              <br />
                              <span class="text-dark">Student Name</span>{" "}
                              &mdash; {student.studentDetails.name} <br />
                              <span class="text-dark">Gender</span> &mdash;{" "}
                              {student.studentDetails.gender}
                              <br />
                              <span class="text-dark">Class</span> &mdash;{" "}
                              {student.currentClass} <br />
                              <span class="text-dark">
                                Section
                              </span> &mdash;{" "}
                              {student.studentDetails.currentSection} <br />
                              <span class="text-dark">
                                Roll No
                              </span> &mdash; {student.studentDetails.rollNo}{" "}
                              <br />
                              <span class="text-dark">House</span> &mdash;{" "}
                              {student.studentDetails.house} <br />
                              <span class="text-dark">
                                Phone No
                              </span> &mdash; {student.studentDetails.phoneNo}
                              <hr className="w-25" />
                              <span class="text-dark">
                                Stoppage
                              </span> &mdash;{" "}
                              <span className="text-capitalize">
                                {student.transportFacility.busStop || "NONE"}
                              </span>
                              <br />
                              <span class="text-dark">
                                Vehicle No
                              </span> &mdash;{" "}
                              {student.transportFacility.vehicleNo || "N/A"}
                              <br />
                              <span class="text-dark">Bus No</span> &mdash;{" "}
                              {student.transportFacility.busNumber || "N/A"}
                              <br />
                              <span class="text-dark">Transport Fee</span>{" "}
                              &mdash;{" "}
                              {student.feeDetails?.transportFee?.amt || "N/A"}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <div className="d-flex align-items-center bg-light rounded-4 mb-2 pe-8">
                                  <div className="p-2 bg-dark rounded-4 opacity-75">
                                    {!student.transportFacility.busStop ? (
                                      <img
                                        src="/assets/images/walker.png"
                                        width="22"
                                      />
                                    ) : (
                                      <img
                                        src="/assets/images/transport.png"
                                        width="22"
                                      />
                                    )}
                                  </div>
                                  <div className="ps-3">
                                    <p className="mb-0 lh-1 fs-5 text-center text-dark">
                                      {!student.transportFacility.busStop
                                        ? "Walker"
                                        : "Bus"}
                                    </p>
                                  </div>
                                </div>

                                <Link
                                  to="/view-student"
                                  state={{
                                    admissionNo:
                                      student.studentDetails.admission_no,
                                  }}
                                  class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  View Details
                                </Link>
                                <Link
                                  to="/update-transport"
                                  state={{
                                    admissionNo:
                                      student.studentDetails.admission_no,
                                  }}
                                  class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Update
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="bg-white rounded-pill">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Transport Management</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Student Details
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div class="bg-danger-soft rounded-4 p-3 d-flex align-items-center">
                        <div class="avatar-group">
                          {[1, 2, 3, 4, 5].map((num) => (
                            <span className="avatar avatar-md" key={num}>
                              <img
                                alt={`avatar-${num}`}
                                src={`/assets/images/students/${num}.jpg`}
                                className="rounded-circle"
                              />
                            </span>
                          ))}
                        </div>
                        <h3 className="fw-bold m-0 text-center fs-4 ms-3">
                          {studentDetails.length.toLocaleString("en-IN")}
                        </h3>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Student Details
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              5.4 MB Size
                            </span>
                          </p>
                        </div>
                        <span
                          onClick={handleExportExcel}
                          className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer"
                        >
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportClassWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Class/Section Wise
                                </span>
                                <span
                                  onClick={handleDownloadBirthdayReport}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Birthday Today
                                </span>
                                <span
                                  onClick={handleExportHouseWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  House - Wise Report
                                </span>
                                <span
                                  onClick={handleExportBusWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Bus No Wise
                                </span>
                                <span
                                  onClick={handleExportGenderWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Gender Wise
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>

                      <div class="mt-1">
                        <div className="row g-1">
                          <div className="col-6">
                            <div
                              onClick={handleExportWalkerStudentsExcel}
                              className="p-3 bg-success-soft rounded-4 cursor-pointer"
                            >
                              <p className="m-0 text-center fw-medium lh-sm text-dark">
                                Walker Students
                              </p>
                              <p className="text-center fs-5 m-0 lh-1">
                                Excel Report
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div
                              onClick={
                                handleExportTransportAvailingStudentsExcel
                              }
                              className="p-3 bg-success-soft rounded-4 cursor-pointer"
                            >
                              <p className="m-0 text-center fw-medium lh-sm text-dark">
                                Availing Transport
                              </p>
                              <p className="text-center fs-5 m-0 lh-1">
                                Excel Report
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default StudentTransportDetails;
